export enum StepType {
  Questionnaire = "questionnaire",
  Instruction = "instruction",
  Conversation = "conversation",
}
